// TODO: Extract from best_in_place gem when Docker is available
// Original source: best_in_place gem vendor/assets/javascripts/best_in_place.js
//
// For now, provide a no-op stub so calling .best_in_place() doesn't throw
(function($) {
  $.fn.best_in_place = function(options) {
    // Stub: best_in_place enables inline editing
    // When the real file is available, replace this stub
    return this;
  };
})(jQuery);
